import React from 'react';
import Marketo from '../marketo';
import {
  getEditorColors,
  isItUndefined,
  modifyLinks,
  renderTextColor,
} from '../../util/DataUtil';

const FacilityMarketo = (data) => {
  const emphasizedTextColor = getEditorColors(
    isItUndefined(data?.children?.field_marketo_main_title),
    isItUndefined(data?.children?.field_marketo_main_description)
  ).filter((x) => x)[0];
  return (
    <div id={'facility-marketo'} className={'facility-marketo main-marketo'}>
      <div className={'container inner-container'}>
        <div className={'left'}>
          <h1
            className={`${renderTextColor(data?.regionColor)} ${emphasizedTextColor ? emphasizedTextColor : ''}`}
            dangerouslySetInnerHTML={{
              __html: modifyLinks(
                isItUndefined(data?.children?.field_marketo_main_title)
              ),
            }}
          />
          <div
            className={`${emphasizedTextColor ? emphasizedTextColor : ''}`}
            dangerouslySetInnerHTML={{
              __html: modifyLinks(
                isItUndefined(data?.children?.field_marketo_main_description)
              ),
            }}
          />
        </div>
        <div className={'form-right'}>
          <Marketo lang={data?.lang} global={data?.global}>
            {{ ...data?.children, lang: data?.lang }}
          </Marketo>
        </div>
      </div>
    </div>
  );
};

export default FacilityMarketo;
